module.exports = __webpack_public_path__ + "static/media/redone-blue-Patchwork-Slim-fit-Jeans.19935139.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/some-extra- womenswear- product-shots/redone-blue-Patchwork-Slim-fit-Jeans.png
// module id = 321
// module chunks = 0